import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import ScrollToTop from "./components/feature/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
       <ScrollToTop />
        <div className="min-h-screen bg-azosis-dark flex flex-col">
          <Navbar />
          <main className="flex-1">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;
